function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import find from 'lodash/find';
import { AppContext } from 'context';
import App, { AlertsBus } from 'modules/App';
import BackToIntegrationApp from 'components/BackToIntegrationApp';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
import ConfirmEmail from '../ConfirmEmail';
import SetNewPasswordCC from '../SetNewPasswordCC';
import ChooseScope from '../ChooseScope';
import ChooseCountry from '../ChooseCountry';
import InvitationInfo from '../InvitationInfo';
import Credentials from './Credentials';
import Mfa from './Mfa';
var _React_PureComponent;
class SignIn extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { availableScopes, availableCountries, isOtpVerified, hasErrors } = props;
        if (state.view === 'MFA' && hasErrors) {
            props.onCancel();
            return {
                view: 'Credentials'
            };
        }
        if (props.inactiveIdentity) {
            return {
                view: 'ConfirmEmail'
            };
        }
        if (props.otpStatus && !isOtpVerified) {
            return {
                view: 'MFA'
            };
        }
        if ((state.view === 'Credentials' || state.view === 'MFA') && availableCountries.length > 1) {
            return {
                view: 'ChooseCountry'
            };
        }
        if ((state.view === 'Credentials' || state.view === 'MFA' || state.view === 'ChooseCountry') && availableScopes.length > 1) {
            return {
                view: 'ChooseScope'
            };
        }
        if (state.view === 'ConfirmEmail' && !props.inactiveIdentity) {
            return {
                view: 'Credentials'
            };
        }
        if (state.view === 'MFA' && !props.otpStatus) {
            return {
                view: 'Credentials'
            };
        }
        return null;
    }
    componentWillUnmount() {
        if (this.props.isInProgress) {
            this.props.onCancel();
        }
    }
    onCancel() {
        this.setState({
            email: null,
            password: null,
            view: 'Credentials'
        });
        this.props.onCancel();
    }
    onSetFormValue(input) {
        const { id, value } = input;
        if (id === 'email') this.setState({
            email: value
        });
        else if (id === 'password') this.setState({
            password: value
        });
        this.props.onSetFormValue(input);
    }
    renderHeader() {
        const { view } = this.state;
        if (view === 'MFA') {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.mfa));
        }
        if (view === 'ChooseCountry') {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.chooseCountry));
        }
        if (view === 'ChooseScope') {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.chooseScope));
        }
        if (!this.props.returnUrl) return null;
        if (!this.app) {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.signIn));
        }
        if (this.props.isMobileDisplayMode) {
            return /*#__PURE__*/ _jsxs("div", {
                className: "headerContainer",
                children: [
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.headers.signInApp), {
                        values: {
                            appName: ''
                        }
                    })),
                    /*#__PURE__*/ _jsx("br", {}),
                    this.app.name
                ]
            });
        }
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.headers.signInApp), {
            values: {
                appName: this.app.name
            }
        }));
    }
    renderIntro() {
        const { view } = this.state;
        if (view === 'MFA') {
            const { identifier } = this.props.otpStatus;
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.intros.provideOTP), {
                values: {
                    identifier: /*#__PURE__*/ _jsx("b", {
                        children: identifier
                    })
                }
            }));
        }
        if (view === 'ChooseCountry') {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.chooseCountry));
        }
        if (view === 'ChooseScope') {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.chooseScope));
        }
        if (!this.props.returnUrl) return null;
        return this.props.isMobileDisplayMode ? null : /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.signIn));
    }
    renderContent() {
        const { view } = this.state;
        if (view === 'MFA') {
            return /*#__PURE__*/ _jsx(Mfa, {
                onSetFormValue: (input)=>this.onSetFormValue(input),
                onCancel: ()=>this.onCancel()
            });
        }
        if (view === 'ChooseCountry') {
            return /*#__PURE__*/ _jsx(ChooseCountry, {
                countries: this.props.availableCountries
            });
        }
        if (view === 'ChooseScope') {
            return /*#__PURE__*/ _jsx(ChooseScope, {
                scopes: this.props.availableScopes,
                returnUrl: this.props.returnUrl
            });
        }
        return /*#__PURE__*/ _jsx(Credentials, {
            returnUrl: this.props.returnUrl,
            onSetFormValue: (input)=>this.onSetFormValue(input)
        });
    }
    render() {
        const { SignInLayout, LogoLayout } = this.props;
        if (this.props.resetPasswordIdentity) {
            return /*#__PURE__*/ _jsx(LogoLayout, {
                children: /*#__PURE__*/ _jsx(SetNewPasswordCC, {
                    email: this.state.email,
                    identityProviderKey: this.props.resetPasswordIdentity.identityProviderKey,
                    temporaryPassword: this.state.password
                })
            });
        }
        if (this.state.view === 'ConfirmEmail') {
            return /*#__PURE__*/ _jsx(LogoLayout, {
                children: /*#__PURE__*/ _jsx(ConfirmEmail, {
                    email: this.state.email,
                    password: this.state.password,
                    returnUrl: this.props.returnUrl
                })
            });
        }
        const Layout = this.props.isMobileDisplayMode ? LogoLayout : SignInLayout;
        const Intro = this.renderIntro();
        return /*#__PURE__*/ _jsxs(Layout, {
            app: this.app,
            children: [
                /*#__PURE__*/ _jsx(BackToIntegrationApp, {
                    to: this.props.returnUrl
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "pageContentBox pageContentBox--sm",
                    children: [
                        /*#__PURE__*/ _jsx("header", {
                            className: "pageHeader",
                            children: /*#__PURE__*/ _jsx("h1", {
                                className: "text--h2",
                                children: this.renderHeader()
                            })
                        }),
                        /*#__PURE__*/ _jsx(InvitationInfo, {
                            className: "mb-6"
                        }),
                        Intro && /*#__PURE__*/ _jsx("p", {
                            className: "text--base text--light mb-5",
                            children: Intro
                        }),
                        /*#__PURE__*/ _jsx(AlertsBus, {
                            className: "mb-5"
                        }),
                        this.renderContent()
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.props.onFetchIdentityProviders();
        this.app = null;
        if (props.clientAppKey) {
            this.app = props.clientAppKey === constants.ACCOUNT_PORTAL.key ? constants.ACCOUNT_PORTAL : find(constants.APPS, {
                key: props.clientAppKey
            });
        }
        this.state = {
            password: null,
            view: 'Credentials'
        };
    }
}
_define_property(SignIn, "contextType", AppContext);
_define_property(SignIn, "propTypes", {
    SignInLayout: PropTypes.object,
    LogoLayout: PropTypes.object,
    returnUrl: PropTypes.string,
    clientAppKey: PropTypes.string,
    // Implicit props
    inactiveIdentity: shapes.identity,
    otpStatus: shapes.otpStatus,
    availableScopes: PropTypes.arrayOf(shapes.scope),
    availableCountries: PropTypes.arrayOf(App.shapes.country),
    resetPasswordIdentity: shapes.identity,
    isOtpVerified: PropTypes.bool,
    isInProgress: PropTypes.bool,
    isMobileDisplayMode: PropTypes.bool,
    hasErrors: PropTypes.bool,
    // Implicit actions
    onCancel: PropTypes.func,
    onFetchIdentityProviders: PropTypes.func,
    // onSetInvitation         : PropTypes.func,
    onSetFormValue: PropTypes.func
});
const mapStateToProps = (state)=>({
        otpStatus: selectors.otpStatus(state),
        availableCountries: selectors.availableCountries(state),
        availableScopes: selectors.availableScopes(state),
        inactiveIdentity: selectors.inactiveIdentity(state),
        resetPasswordIdentity: selectors.resetPasswordIdentity(state),
        isOtpVerified: selectors.isOtpVerified(state),
        isInProgress: selectors.isSignInInProgress(state),
        hasErrors: selectors.hasSignInErrors(state),
        isMobileDisplayMode: App.selectors.isMobileDisplayMode(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onCancel: ()=>dispatch(actions.signInCancel()),
        onFetchIdentityProviders: ()=>dispatch(actions.fetchIdentityProviders()),
        // onSetInvitation         : () => dispatch(actions.setInvitation()),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(constants.SIGN_IN_FORM, input))
    });
const ConnectedSignIn = connect(mapStateToProps, mapDispatchToProps)(SignIn);
export default ConnectedSignIn;
